/* eslint-disable curly */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-no-duplicate-props */
import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import './App.scss';
import { BrowserRouter as Router, withRouter } from 'react-router-dom';
import TopNav from 'Components/top-nav/topNav';
import Routes from 'Routes/routes';
import * as CONSTANTS from 'Utils/constants';
import { Utils } from 'Utils/utils';
import LoadingWrapper from 'Components/common/loadingWrapper';
import { ConfirmationPopup } from 'Components/common/confirmationPopup';
import { InputBoxPopup } from 'Components/common/inputPopup';
import { PurchaseStatusPopup } from 'Components/common/purchaseStatusPopup';
import CommonWarningPopup from 'Components/common/commonWarningPopup';
import { PricingPayment } from 'Components/common/pricingPopup';
import { loginValidate } from 'Utils/commonApi';
import { userDetail } from 'Stores/userDetail';
import { Toaster } from 'Components/common/toaster';
import ConnectionErrorMsgWrapper from 'Pages/integration/connectionErrorMsgWrapper';
import PaidUserWelcomePopup from 'Components/common/paidUserWelcomePopup';
import TrialFormPopup from 'Components/common/trialFormPopup';
import TrialUserPaginationPopup from 'Components/common/trialUserPaginationPopup';
import PaidUserTechnologyFilterPopup from 'Components/common/paidUserTechnologyFilterPopup';
import G2ReviewPopup from 'Components/common/g2ReviewPopup';
import freeTrialPopupState from 'Stores/freeTrialPopupState';
import { PaygPurchaseMorePopup } from 'Components/common/paygPurchaseMorePopup';
import RequestQuoteFormPopup from 'Components/common/requestQuoteFormPopup';
import UpdateUserEmailPopup from 'Components/common/updateUserEmail';
import { UpgradeCreditPopup } from 'Components/common/upgradeCreditPopup';
import OnboardingFloater from 'Components/personalisedOnboarding/onboardingFloater';
import { personalisedOnboardingState } from 'Stores/personalisedOnboardingState';
import ProspectorFreeTrialPopup from './components/common/prospectorFreeTrialPopup';
import CommonMsgPopup from './components/common/commonMsgPopup';
import CommonUpgradePopup from './components/common/commonUpgradePopup';

const MainContentSection = withRouter(
  observer(props => {
    const { showNotificationType = '' } = userDetail;
    const { location } = props;

    return (
      <section
        className={`site-content${
          showNotificationType !== '' && Utils.checkAndShowNewFeature(props)
            ? ' hasNotififcationBar'
            : ''
        }`}
      >
        <Routes />
        <ConfirmationPopup />
        <CommonWarningPopup />
        <InputBoxPopup />
        <CommonMsgPopup />
      </section>
    );
  }),
);

const App = observer(props => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const {
    isFreeTrial,
    showActivateAccountPage,
    showPasswordSetupPage,
  } = userDetail;
  const { freeTrialPrePopup = false } = freeTrialPopupState;

  const {
    isPersonalisedOnboardingFlow,
    onboardingCurrentStep,
  } = personalisedOnboardingState;

  const loginCheck = async () => {
    await loginValidate(true, true);
    Utils.registerMixpanel();
    setTimeout(() => {
      setIsLoggedIn(true);
      // Utils.checkAndShowFreeTrialOneTimePopup();
      Utils.addSessionRecordingForTrialUser();
      // Utils.addSessionRecordingForLbPaidUser();
      Utils.checkAndShowAccountActivationToast();
      Utils.checkAndShowTrialActivationToast();
      Utils.setRefinerProject();
    }, 500);
  };

  useEffect(() => {
    loginCheck();
  }, []);

  return !isLoggedIn ? (
    <LoadingWrapper show={!isLoggedIn} position="fixed" />
  ) : (
    <Router>
      {isFreeTrial && (
        <>
          <TrialUserPaginationPopup />
        </>
      )}

      <OnboardingFloater />
      <UpgradeCreditPopup />
      <PaidUserWelcomePopup />
      <PaidUserTechnologyFilterPopup />

      <PurchaseStatusPopup />
      <PricingPayment />
      <TrialFormPopup />
      <RequestQuoteFormPopup />
      <Toaster />
      <ConnectionErrorMsgWrapper />
      <G2ReviewPopup />
      <PaygPurchaseMorePopup />
      <UpdateUserEmailPopup />
      <CommonUpgradePopup />

      {freeTrialPrePopup && <ProspectorFreeTrialPopup />}
      <div
        className={`content-wrapper ${
          showActivateAccountPage ? ' activate-account-flow' : ''
        } ${showPasswordSetupPage ? ' password-setup-flow' : ''} ${
          isPersonalisedOnboardingFlow !== null
            ? ` personalised-onboarding-flow ${isPersonalisedOnboardingFlow}`
            : ''
        }`}
        id={`${
          isPersonalisedOnboardingFlow !== null
            ? `${isPersonalisedOnboardingFlow + onboardingCurrentStep}`
            : ''
        }`}
      >
        <TopNav />
        <MainContentSection />
      </div>
    </Router>
  );
});

export default App;
